module.exports = __webpack_public_path__ + "static/media/xcode.b14bf7ce.png";